module.exports = __webpack_public_path__ + "static/media/0003.78c0b74b.jpg";